import styled, { css } from 'styled-components'
import theme from 'live/services/theme'

export const LiveListRow = styled.li`
    border-radius: 3px;
    border: solid 1px ${({ theme }) => theme['gray-dark-bg']};
    margin-bottom: 10px;
    height: 50px;
    display: flex;
    align-items: center;
    padding-left: 15px;
    padding-right: 15px;
    cursor: pointer;
    transition: box-shadow 0.15s ease-out, border-color 0.15s ease-out;
    will-change: box-shadow, border-color;

    > div:nth-child(1) {
        font-size: 14px;
        font-family: ${({ theme }) => theme['font-bold']};
    }

    &:hover {
        box-shadow: 0 1px 8px 0 rgba(54, 65, 89, 0.3);
        border: solid 1px ${({ theme }) => theme['link-color']};
    }
`

export const ListRow = styled(LiveListRow)`
    display: flex;
    margin-bottom: unset;
    border-radius: unset;
`
export const ListHeader = styled.div<{ width?: number }>`
    display: flex;
    padding: 10px 15px;
    position: sticky;
    background: white;
    top: 0;
    z-index: 100;
`

interface ListItemProps {
    width?: number
}

export const ListRowItem = styled.div<ListItemProps>`
    ${({ width }) =>
        width !== undefined
            ? css`
                  width: ${width}px;
              `
            : css`
                  flex: 1;
              `}
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${theme['text-color']};
    padding: 15px 5px;
`
export const ListHeaderItem = styled.div<ListItemProps>`
    ${({ width }) =>
        width !== undefined
            ? css`
                  width: ${width}px;
              `
            : css`
                  flex: 1;
              `}
    > div {
        text-transform: uppercase;
        font-weight: 550;
        color: ${theme['text-color']};
        cursor: pointer;

        .fa {
            margin-left: 6px;
            color: ${theme['text-color']};
            margin-right: 13px;
        }
    }
`

export const ListBody = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    max-height: 100%;
    overflow: auto;
`
export const Container = styled.div<{maxHeight?: string }>`
    width: 100%;
    height: ${props => (props.maxHeight ? props.maxHeight : `100%`)};
`
export const FooterContainer = styled.div`
    padding: 10px 0;
    border-top: 1px solid ${theme['bg-body']};
`
